import { render, staticRenderFns } from "./modalDescripcionNuevoLeechero.vue?vue&type=template&id=461d27b6&"
import script from "./modalDescripcionNuevoLeechero.vue?vue&type=script&lang=js&"
export * from "./modalDescripcionNuevoLeechero.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports